import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

// Bootstrap imports - ADD THESE
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// import Dashboard from "./pages/Home";
import Layout from "./components/Layout";
import ShowEvents from "./features/EventOrganiser/events/show";
import userStore from "./zustand/userStore";
import "./stylesheets/Custom.css";
import AddEvent from "./features/EventOrganiser/events/addEvent";
import NoteSheet from "./features/EventOrganiser/events/NoteSheet";
import ActivityDetails from "./features/EventOrganiser/events/ActivityDetails";
import AllIPCostingPage from "./features/EventOrganiser/costsheet/AllIPCostingPage";
import AddItemProductCostingPage from "./features/EventOrganiser/costsheet/AddItemProductCostingPage";
import CostingAddItems from "./features/EventOrganiser/costsheet/CostingAddItems";
import UploadedDocuments from "./features/EventOrganiser/upload-document";
import {
  Upload,
  ViewUploadedDocuments,
} from "./features/EventOrganiser/upload-document/uploaded-documents";
import Login from "./pages/Login";
// import Home from "./pages/LandingPage";
import { useSelector } from "react-redux";
import ManageData from "./features/SchoolModule/ManageData.jsx";
import MyDocuments from "./features/EventOrganiser/myDocuments/MyDocuments.js";
import MyDocFormDraft from "./features/EventOrganiser/myDocuments/Drafts.js";
import DocFormTestRunNew from "./features/EventOrganiser/docForm/TestRunNew.js";
import MyDocFormRecords from "./features/EventOrganiser/myDocuments/Records.js";
import MyDocFormViewFilled from "./features/EventOrganiser/myDocuments/ViewFilled.js";
import UserShowAll from "./pages/user/ShowAll2.js";
import UserAdd from "./pages/user/Add2.js";
import QuestionPaper from "./features/QuestionPaper/questionPaper.js";
import QuestionPaperLayout from "./features/QuestionPaper/components/layout.js";
import CreateQuestionPaper from "./features/QuestionPaper/createpaper/createQuestionPaper.js";
import CustomCalendar from "./features/AcademicCalendar/CustomCalendar.js";
import AcademicCalendar from "./features/AcademicCalendar/AcademicCalendar.js";
import CreateUser from "./pages/user/createUser.js";
import UserList from "./pages/user/show.js";
import QuestionBank from "./features/QuestionBank/question_bank.js";
import CreateMaster from "./pages/masterData/createMaster.js";
import QuestionPapers from "./features/QuestionPaper/createpaper/components/questionPapers.js";
import WorkSheets from "./features/QuestionPaper/createpaper/components/workSheets.js";
import "./Theme.css";
import Show from "./pages/prefills/show.js";
import TimetableLayout from "./features/SchoolModule/components/Timetablelayout.js";
import TeachersPlanner from "./features/TeachersPlanner/CustomCalendar.js";
import ClassManagement from "./features/SchoolModule/classes/ClassManagement.js";
import SubjectManagement from "./features/SchoolModule/subjects/SubjectManagement.jsx";
import SectionManagement from "./features/SchoolModule/sections/SectionManagement.jsx";
import TeacherManagement from "./features/SchoolModule/teachers/TeacherManagement.jsx";
import GenerateTimetableManagement from "./features/SchoolModule/generateTimetable/GenerateTimetableManagement.js";
import SubstituteTeacherManagement from "./features/SchoolModule/substituteTeacher/SubstituteTeacherManagement.jsx";
import ViewTeacherTimeTableManagement from "./features/SchoolModule/generateTimetable/ViewTeacherTimeTableManagement.js";
import PeriodManagement from "./features/SchoolModule/periods/PeriodManagement.jsx";
import TeacherPlannerLayout from "./features/TeachersPlanner/components/TeacherPlannerLayout.js";
import SyllabusUploadForm from "./features/TeachersPlanner/SyllabusUploadForm.js";
import ShowTimeTable from "./features/TeachersPlanner/TimeTable/ShowTimeTable.js";
import ShowProjects from "./features/TeachersPlanner/Projects/ShowProjects.js";
import AwarenessDetailsPage from "./features/AcademicCalendar/components/AwarenessDetailsPage.js";
import ViewSyllabus from "./features/TeachersPlanner/Projects/viewSyllabus.js";
import CelebrationDetailsPage from "./features/AcademicCalendar/components/Celebrations/CelebrationDetailsPage.js";
import DocumentDashboardLayout from "./components/DocumentDashboardLayout.js";
import SyllabusStage2 from "./features/TeachersPlanner/SyllabusStage2.js";
import EventRequestTab from "./features/EventOrganiser/events/EventRequestTab.js";
import ShowLessons from "./features/TeachersPlanner/WeeklyLessons/ShowLessons.js";
import TabContainer from "./features/TeachersPlanner/Projects/TabContainer.js";
import MyHomeworks from "./features/TeachersPlanner/WeeklyLessons/HomeWorks/MyHomeworks.js";
import MyProjects from "./features/TeachersPlanner/WeeklyLessons/Projects/MyProjects.js";
import SignupPage from "./pages/SignupPage.js";
import ForOthersRegistrationForm from "./pages/ForOthersRegistrationForm.js";
import About from "./pages/About.js";
import otpVerificaton from "./pages/otpVerificaton.js";
import AllteacherTimetable from "./features/TeachersPlanner/TimeTable/AllteacherTimetable.js";
import UserAiIntegration from "./pages/userAiKeys/userAiCredentials.js";
import Pricing from "./pages/Pricing.js";
// import PricingPage from "./features/pricing/pricing.js";
import PricingPage from "./features/pricing/pricing_27_04.js";
// import TicketingApp from "./features/ticketing-app/ticketing-main.js";
import TicketingLayout from "./features/ticketing-app/components/ticketing-navbar.js";
import ViewTickets from "./features/ticketing-app/viewTickets.js";
import CreateTicket from "./features/ticketing-app/create-ticket.js";
import AdminLessons from "./features/TeachersPlanner/WeeklyLessons/AdminLessons.js";
import WeeklyLessonNav from "./features/TeachersPlanner/WeeklyLessons/weeklyLessonNav.js";
import TimetableNav from "./features/TeachersPlanner/WeeklyLessons/TimetableNav.js";
import AdminSyllabus from "./features/TeachersPlanner/Projects/AdminSyllabus.js";
import ProjectNav from "./features/TeachersPlanner/WeeklyLessons/ProjectNav.js";
import HomeworkNav from "./features/TeachersPlanner/WeeklyLessons/HomeworkNav.js";
import OtpVerification from "./pages/otpVerificaton.js";
import Eligibility from "./features/EligibilityData/eligibility.js";
import AdminUploadSyllabus from "./features/TeachersPlanner/AdminUploadSyllabus.js";
import SyllabusStage3 from "./features/TeachersPlanner/SyllabusStage3.js";
import { Toaster } from "react-hot-toast";
import { lazy, Suspense, useEffect } from "react";
import QuizMainComponent from "./features/Quiz-app/components/quiz-main.js";
import UserDashboard from "./features/Quiz-app/pages-new/UserDashboard.js";
import RegisteredQuizzes from "./features/Quiz-app/pages-new/Registered-quizzes.js";
import CompletedQuizzes from "./features/Quiz-app/pages-new/Completed-quizzes.js";
import AboutQuiz from "./features/Quiz-app/pages-new/About-quiz.js";
import QuizReady from "./features/Quiz-app/pages-new/Quiz-ready.js";
import TermsAndConditions from "./features/Quiz-app/pages-new/Terms-And-conditions.js";
import StartQuiz from "./features/Quiz-app/pages-new/StartQuiz.js";
import Students from "./features/Quiz/Students.js";
import QuizLayout from "./features/Quiz/QuizLayout.js";
import QuizLogin from "./features/Quiz-app/pages/QuizLogin.js";
import QuizRegister from "./features/Quiz-app/pages/QuizRegister.js";
import Leaderboard from "./features/Quiz/Leaderboard.js";
import QuizHomePage from "./QuizLandingPage.js";
import StudentQuizComponent from "./features/StudentQuiz/components/StudentQuizComponent.js";
import StudentDashboard from "./features/StudentQuiz/pages/StudentDashboard.js";
import StudentQuizDetails from "./features/Quiz/StudentQuizDetails.js";
import StartQuiz2 from "./features/StudentQuiz/pages/StartQuiz2.js";
import CompletedQuizzes2 from "./features/StudentQuiz/pages/CompletedQuizzes2.js";
import AboutQuiz2 from "./features/StudentQuiz/pages/AboutQuiz2.js";
import RegisteredQuizzes2 from "./features/StudentQuiz/pages/RegisteredQuizzes2.js";
import QuizReady2 from "./features/StudentQuiz/pages/QuizReady2.js";
import TermsAndConditions2 from "./features/StudentQuiz/pages/TermsAndConditions2.js";
import Syllabus from "./features/student/Syllabus.js";
import Newdashboard from "./features/student/Newdashboard.js";
import Testimonials from "./features/student/Testimonials.js";
import Howtopartcipate from "./features/student/Howtopartcipate.js";
import Contact from "./features/student/Contact.js";
import StudentQuizLayout from "./features/student/components/StudentQuizLayout.js";
import StudentQuizComponent2 from "./features/student/components/StudentQuizComponent2.js";
import StudentsDocumentLayout from "./features/student/components/DocumentDashboardLayout.js";
import Documents from "./features/student/documents/Documents.js";
import DocFormTestRun from "./features/student/documents/TestRunNew.js";
import Draft from "./features/student/documents/Draft.js";
import MyDocumentForms from "./features/student/documents/Records.js";
import MyDocFormViewFill from "./features/student/documents/ViewFilled.js";
import ForgotPassword from "./pages/ForgotPassword.js";
import RegistrationForm from "./pages/RegistrationForm.js";
import Profile from "./pages/Profile.js";
import IdleTimeControl from "./IdleTimerControl.js";
import ForgotPassword2 from "./pages/ForgotPassowrd2.js";
import RegistrationSuccess from "./pages/RegistrationSuccess.js";
// import GlobalJoyride from "./components/GlobalJoyride.js"
// import FloatingBadge from "./components/FloatingBadges.js";
import Topinfobar from "./components/Topinfobar.js";
import ContactBar from "./components/ContactBar.js";
import AllPapers from "./features/QuestionPaper/AllPapers/allPapers.js";
import GlobalJoyride from "./components/GlobalJoyride.jsx";
import MdmPaywall from "./MdmPaywall.jsx";
import MdmPaywallPreview from "./MdmPaywallv2.jsx";
import UserDeletedModal from "./components/UserDeletedModal.js";
import TutorPricing from "./pages/pricing-plans/TutorPricing.js";
import CoachingPricing from "./pages/pricing-plans/CoachingPricing.js";
import AllPlansPage from "./pages/pricing-plans/AllPlansPage.js";
import UserLandingPage from "./pages/GuestUser/UserLandingPage.js";
import GuestUserHome from "./pages/GuestUserHome.js";
// LMS Admin
import LmsLayout from "./features/lms/LmsLayout";
import StudentLmsLayout from "./features/lms/StudentLmsLayout";
import TeacherLmsLayout from "./features/lms/TeacherLmsLayout";
import LmsDashboard from "./features/lms/pages/LmsDashboard";
import LmsRecordings from "./features/lms/pages/LmsRecordings";
import MasterSetup from "./features/lms/pages/MasterSetup";
import Courses from "./features/lms/pages/Courses";
import PaymentConfig from "./features/lms/pages/PaymentConfig";
import LmsStudents from "./features/lms/pages/Students";
import StudentHistoryLayout from "./features/lms/pages/StudentHistoryLayout";
import StudentPaymentDetails from "./features/lms/pages/StudentPaymentDetails";
import StudentCourseRequests from "./features/lms/pages/StudentCourseRequests";
import LmsTeachers from "./features/lms/pages/Teachers";
import CourseDetail from "./features/lms/pages/CourseDetail";
import Exams from "./features/lms/pages/Exams";
import ManualPaperBuilder from "./features/lms/pages/ManualPaperBuilder";
import LiveClasses from "./features/lms/pages/LiveClasses";
import LiveClassAuditLog from "./features/lms/pages/LiveClassAuditLog";
import AttendanceManagement from "./features/lms/pages/AttendanceManagement";
import StudentAttendance from "./features/lms/pages/StudentAttendance";
import StudentCourseDetail from "./features/lms/pages/StudentCourseDetail";
import StudentCourses from "./features/lms/pages/StudentCourses";
import StudentAvailableCourses from "./features/lms/pages/StudentAvailableCourses";
import StudentEnrolledCourses from "./features/lms/pages/StudentEnrolledCourses";
import StudentRequestedCourses from "./features/lms/pages/StudentRequestedCourses";
import StudentPaymentHistoryLedger from "./features/lms/pages/StudentPaymentHistoryLedger";
import TeacherDashboard from "./features/lms/pages/TeacherDashboard";
import TeacherCourses from "./features/lms/pages/TeacherCourses";
import TeacherLiveClasses from "./features/lms/pages/TeacherLiveClasses";
import TeacherExams from "./features/lms/pages/TeacherExams";
import StudentExams from "./features/lms/pages/StudentExams";
import StudentManualPaperViewer from "./features/lms/pages/StudentManualPaperViewer";
import StudentLiveClasses from "./features/lms/pages/StudentLiveClasses";
import Batches from "./features/lms/pages/Batches";
import NoticeBoard from "./features/lms/pages/NoticeBoard";
import StudentNoticeBoard from "./features/lms/pages/StudentNoticeBoard";
import StudentOnlineExam from "./features/lms/pages/StudentOnlineExam";
import OnlineExamResults from "./features/lms/pages/OnlineExamResults";
function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector(
    (state) => state.authSlice.isAuthenticated,
  );
  return isAuthenticated ? children : <Navigate to="/home" />;
}

const ProtectedQuizRoute = ({ children }) => {
  const isQuizAuthenticated = useSelector(
    (state) => state.studentQuiz.isAuthenticated,
  );
  return isQuizAuthenticated ? children : <Navigate to="/quiz" />;
};

function NotGuestRoute({ children }) {
  const userData = userStore((state) => state.user);

  if (!userData) return null; // or loader

  if (userData.roles === "guest_user") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
function ConditionalTopInfoBar() {
  const location = useLocation();
  const showOnRoutes = [
    "/home",
    "/pricing",
    "/Pricing",
    "/dashboard",
    "/",
    "/About",
  ];
  if (!showOnRoutes.includes(location.pathname)) return null;
  return <Topinfobar />;
}

function ConditionalContactBar() {
  const location = useLocation();
  const path = location.pathname;

  // Landing page has its own contact bar inside Header.js — skip global one
  if (path === "/home") return null;

  // Show ONLY on pricing page and main dashboard home pages
  // (matches the web version where numbers appear in the navbar header)
  const showRoutes = ["/pricing", "/dashboard", "/"];
  if (!showRoutes.includes(path)) return null;

  return <ContactBar />;
}

// function MetaPixelPageTracker() {
//   const location = useLocation();

//   useEffect(() => {
//     if (typeof window !== "undefined" && typeof window.fbq === "function") {
//       window.fbq("track", "PageView");
//     }
//   }, [location.pathname]);

//   return null;
// }

// function GlobalMdmWidgetManager() {
//   const location = useLocation();

//   useEffect(() => {
//     document.body.classList.add("mobile-mdm-widget-safe");

//     const isMobileViewport = () =>
//       window.matchMedia("(max-width: 768px)").matches;

//     const clearWidgetClasses = () => {
//       document
//         .querySelectorAll(".mdm-demo-help-widget, .mdm-bubble-widget")
//         .forEach((element) => {
//           element.classList.remove(
//             "mdm-demo-help-widget",
//             "mdm-bubble-widget",
//           );
//         });
//     };

//     const tagFloatingWidgets = () => {
//       clearWidgetClasses();

//       if (!isMobileViewport()) return;

//       const candidates = Array.from(
//         document.querySelectorAll(
//           [
//             'iframe[src*="appd"]',
//             'iframe[src*="mdm"]',
//             '[id*="mdm"]',
//             '[class*="mdm"]',
//             '[data-mdm-widget]',
//             '[title*="Demo"]',
//             '[title*="Help"]',
//             '[aria-label*="Demo"]',
//             '[aria-label*="Help"]',
//             '[style*="position: fixed"]',
//           ].join(", "),
//         ),
//       );

//       candidates.forEach((element) => {
//         const styles = window.getComputedStyle(element);

//         if (styles.position !== "fixed") return;

//         const rect = element.getBoundingClientRect();
//         const src = element.getAttribute("src") || "";
//         const descriptor = [
//           element.textContent,
//           element.getAttribute("title"),
//           element.getAttribute("aria-label"),
//           element.id,
//           element.className,
//           src,
//         ]
//           .filter(Boolean)
//           .join(" ")
//           .toLowerCase();

//         const nearBottom = rect.bottom >= window.innerHeight - 220;
//         const nearRight = rect.right >= window.innerWidth - 160;
//         const isWidePill = rect.width >= 110 && rect.height <= 80;
//         const isCompactBubble = rect.width <= 90 && rect.height <= 90;

//         if (
//           nearBottom &&
//           (descriptor.includes("demo") ||
//             descriptor.includes("help") ||
//             ((src.includes("appd") || src.includes("mdm")) && isWidePill))
//         ) {
//           element.classList.add("mdm-demo-help-widget");
//           return;
//         }

//         if (
//           nearBottom &&
//           nearRight &&
//           (descriptor.includes("appd") ||
//             descriptor.includes("mdm") ||
//             isCompactBubble)
//         ) {
//           element.classList.add("mdm-bubble-widget");
//         }
//       });
//     };

//     const scheduleTagging = () => {
//       window.requestAnimationFrame(tagFloatingWidgets);
//     };

//     const observer = new MutationObserver(scheduleTagging);

//     scheduleTagging();
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//       attributeFilter: ["class", "style", "title", "aria-label", "src"],
//     });
//     window.addEventListener("resize", scheduleTagging);

//     return () => {
//       observer.disconnect();
//       window.removeEventListener("resize", scheduleTagging);
//       clearWidgetClasses();
//       document.body.classList.remove("mobile-mdm-widget-safe");
//     };
//   }, [location.pathname]);

//   return null;
// }

const Dashboard = lazy(() => import("./pages/Home"));
const MainDashboard = lazy(() => import("./pages/MainDashboard.js"));
const Home = lazy(() => import("./pages/LandingPage"));
const TutorHome = lazy(() => import("./pages/tutor/TutorHome.js"));
const CoachingHome = lazy(() => import("./pages/coaching/CoachingHome.js"));

function App() {
  return (
    <Router>
      {/* <MetaPixelPageTracker /> */}
      {/* <GlobalMdmWidgetManager /> */}
      {/* <IdleTimeControl /> */}
      <Suspense fallback={<div>Loading...</div>}>
        <UserDeletedModal />
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerStyle={{
            top: "55px",
            right: "20px",
          }}
        />
        {/* <FloatingBadge /> */}
        {/* <GlobalJoyride />  */}
        <ConditionalContactBar />
        <ConditionalTopInfoBar />
        <Routes>
          {/* <Route path="/signup" element={<SignupPage />} /> */}
          <Route path="/signup" element={<RegistrationForm />} />
          <Route
            path="/for-others-registration"
            element={<ForOthersRegistrationForm />}
          />
          <Route path="/otp" element={<OtpVerification />} />
          <Route
            path="/registration-success"
            element={<RegistrationSuccess />}
          />
          {/* <Route path="/paywall" element={<ProtectedRoute><MdmPaywall /></ProtectedRoute>} /> */}
          <Route
            path="/paywall"
            element={
              <ProtectedRoute>
                <MdmPaywallPreview />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
          <Route path="/forgot-password" element={<ForgotPassword2 />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                {" "}
                <Profile />{" "}
              </ProtectedRoute>
            }
          />
          <Route path="/ai-integrate" element={<UserAiIntegration />} />
          <Route path="/pricing" element={<PricingPage />} />

          <Route path="/registration" element={<RegistrationForm />} />
          <Route path="/eligibilityForm" element={<Eligibility />} />
          <Route path="/About" element={<About />} />
          <Route path="/quiz" element={<QuizLogin />} />
          <Route path="/quiz/register" element={<QuizRegister />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                {/* <Dashboard /> */}
                <MainDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tutor"
            element={
              <ProtectedRoute>
                <TutorHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coaching"
            element={
              <ProtectedRoute>
                <CoachingHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                {/* <Dashboard /> */}
                <MainDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/tutor/pricing"
            element={
              <ProtectedRoute>
                <TutorPricing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coaching/pricing"
            element={
              <ProtectedRoute>
                <CoachingPricing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all-plan"
            element={
              <ProtectedRoute>
                <AllPlansPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-landing"
            element={
              <ProtectedRoute>
                <UserLandingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/guest-home"
            element={
              <ProtectedRoute>
                <GuestUserHome />
              </ProtectedRoute>
            }
          />

          <Route
            path="/timetable"
            element={
              <ProtectedRoute>
                <TimetableLayout />
              </ProtectedRoute>
            }
          >
            <Route path="classes" element={<ClassManagement />} />
            <Route path="subjects" element={<SubjectManagement />} />
            <Route path="sections" element={<SectionManagement />} />
            <Route path="teachers" element={<TeacherManagement />} />
            <Route path="periods" element={<PeriodManagement />} />

            <Route
              path="generatetimetable"
              element={<GenerateTimetableManagement />}
            />
            <Route
              path="substitute"
              element={<SubstituteTeacherManagement />}
            />
            <Route
              path="teachertimetable"
              element={<ViewTeacherTimeTableManagement />}
            />
          </Route>

          {/* documents */}
          <Route
            // path="/documents"
            element={
              <ProtectedRoute>
                <DocumentDashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route exact path="/myDocuments" element={<MyDocuments />} />
            {/* <Route path="myDocuments" element={<MyDocuments />} /> */}
            {/* <Route path="myDocFormDraft/:isDraft" element={<MyDocFormDraft />} /> */}
            <Route
              exact
              path="/myDocFormDraft/:isDraft"
              element={<MyDocFormDraft />}
            />
            <Route exact path="/myDocForms" element={<MyDocFormRecords />} />
            <Route path="/prefills" element={<Show />} />
            <Route
              exact
              path="/docFormTestRunNew"
              element={<DocFormTestRunNew />}
            />
            <Route
              exact
              path="/myDocFormViewFilled"
              element={<MyDocFormViewFilled />}
            />

            {/* <Route path="myDocForms" element={<MyDocFormRecords />} /> */}
            {/* <Route path="prefills" element={<Show />} /> */}
          </Route>

          <Route
            // path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {/* <Route index element={<Home />} /> */}
            {/* <Route path="/raiseYourConcern" element={<TicketingApp />} /> */}

            <Route path="/requestEvent" element={<EventRequestTab />} />
            <Route path="/ShowEvents" element={<ShowEvents />} />
            <Route path="/addEvent" element={<AddEvent />} />
            <Route path="/eventNotes" element={<NoteSheet />} />
            <Route
              exact
              path="/activity-details"
              element={<ActivityDetails />}
            />
            <Route
              exact
              path="/showallipcosting"
              element={<AllIPCostingPage />}
            />
            <Route
              exact
              path="/addipcosting"
              element={<AddItemProductCostingPage />}
            />
            <Route
              exact
              path="/costingAddItems"
              element={<CostingAddItems />}
            />
            <Route
              exact
              path="/uploadedDocuments"
              element={<UploadedDocuments />}
            />
            <Route
              exact
              path="/viewUploadedDocuments"
              element={<ViewUploadedDocuments />}
            />
            <Route exact path="/uploadDocuments" element={<Upload />} />

            {/* <Route exact path="/myDocuments" element={<MyDocuments />} /> */}

            {/* Documents related part */}
            {/* <Route
            exact
            path="/docFormTestRunNew"
            element={<DocFormTestRunNew />}
          /> */}
            {/* <Route
            exact
            path="/myDocFormDraft/:isDraft"
            element={<MyDocFormDraft />}
          /> */}
            {/* <Route exact path="/myDocForms" element={<MyDocFormRecords />} /> */}

            <Route exact path="/userShowAll" element={<UserShowAll />} />
            <Route exact path="/userAdd" element={<UserAdd />} />
            <Route exact path="/createUser" element={<CreateUser />} />
            <Route exact path="/userList" element={<UserList />} />
            <Route exact path="/createMaster" element={<CreateMaster />} />
            {/* <Route path="/prefills" element={<Show />} /> */}
            {/* <Route path="/teachersPlanner" element={<TeachersPlanner />} /> */}

            <Route path="/calsses" element={<ClassManagement />} />
            <Route path="/subjects" element={<SubjectManagement />} />
            <Route path="/sections" element={<SectionManagement />} />
            <Route path="/teachers" element={<TeacherManagement />} />
            <Route
              path="/timetable"
              element={<GenerateTimetableManagement />}
            />
            <Route
              path="/substitute"
              element={<SubstituteTeacherManagement />}
            />
          </Route>

          <Route
            element={
              <ProtectedRoute>
                <QuestionPaperLayout />
              </ProtectedRoute>
            }
          >
            <Route exact path="/qstnPaper" element={<QuestionPaper />} />
            <Route
              exact
              path="/createPaper"
              element={<CreateQuestionPaper />}
            />
            <Route exact path="/qstnPapers" element={<QuestionPapers />} />
            <Route exact path="/workSheets" element={<WorkSheets />} />
            <Route exact path="/questionBank" element={<QuestionBank />} />
            {/* <Route exact path="/allPapers" element={<AllPapers />} /> */}
            <Route
              path="/allPapers"
              element={
                <NotGuestRoute>
                  <AllPapers />
                </NotGuestRoute>
              }
            />
          </Route>

          <Route
            element={
              <ProtectedRoute>
                <TeacherPlannerLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/teachersPlanner" element={<TeachersPlanner />} />
            <Route path="/myTimeTable" element={<ShowTimeTable />} />
            <Route
              path="/allTeachersPlanner"
              element={<AllteacherTimetable />}
            />
            <Route path="/uploadSyllabus" element={<SyllabusUploadForm />} />
            <Route
              path="/adminUploadSyllabus"
              element={<AdminUploadSyllabus />}
            />
            <Route path="/showProjects" element={<ShowProjects />} />
            <Route path="/listoftabs" element={<TabContainer />} />
            <Route path="/viewSyllabus" element={<ViewSyllabus />} />
            <Route path="/stage2" element={<SyllabusStage2 />} />
            <Route path="/stage3" element={<SyllabusStage3 />} />
            <Route path="/weeklyPlan" element={<ShowLessons />} />
            <Route path="/myHomeWorks" element={<MyHomeworks />} />
            <Route path="/myprojects" element={<MyProjects />} />
            <Route path="/allTeachersweeklyPlan" element={<AdminLessons />} />
            <Route path="/weeklyLessons" element={<WeeklyLessonNav />} />
            <Route path="/alltimeTable" element={<TimetableNav />} />
            <Route path="/allSyllabus" element={<AdminSyllabus />} />
            <Route path="/allProjects" element={<ProjectNav />} />
            <Route path="/allHomeworks" element={<HomeworkNav />} />
          </Route>
          <Route
            element={
              <ProtectedRoute>
                <QuizLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/quizList" element={<Students />} />
            <Route path="/aboutQuiz1" element={<AboutQuiz2 />} />
            <Route path="quizSyllabus" element={<Syllabus />} />

            <Route path="/quizList1" element={<StudentQuizDetails />} />
            <Route path="/leaderBoard" element={<Leaderboard />} />
            {/* <Route path="/quizHome" element={<QuizHome />} /> */}
          </Route>

          {/* <Route element={<TimetableLayout />}>
          <Route path="/schoolmanagement" element={<ManageData />} />
        </Route> */}
          <Route path="/create-ticket" element={<CreateTicket />} />

          <Route
            element={
              <ProtectedRoute>
                <TicketingLayout />
              </ProtectedRoute>
            }
          >
            {/* <Route path="/raiseYourConcern" element={<TicketingApp />} /> */}
            <Route path="/createTicket" element={<CreateTicket />} />
            <Route path="/viewTickets" element={<ViewTickets />} />
          </Route>
          {/* <Route element={<ProtectedRoute />}> */}
          <Route exact path="/calendarview" element={<AcademicCalendar />} />
          <Route
            exact
            path="/awareness-details/:idOrDate"
            element={<AwarenessDetailsPage />}
          />
          <Route
            exact
            path="/celebration-details/:idOrDate"
            element={<CelebrationDetailsPage />}
          />
          {/* for school students */}
          {/* <Route
            path="/quiz-new"
            element={
              <ProtectedRoute>
                <QuizMainComponent />
              </ProtectedRoute>
            }
          >
            <Route index element={<UserDashboard />} />
            <Route path="dashboard" element={<UserDashboard />} />{" "}
            <Route path="registered-quizzes" element={<RegisteredQuizzes />} />
            <Route path="completed-quizzes" element={<CompletedQuizzes />} />
            <Route path="about-quiz" element={<AboutQuiz />} />
            <Route path="ready/:quiz_id" element={<QuizReady />} />
            <Route
              path="terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="start-quiz/:quiz_id" element={<StartQuiz />} />
          </Route> */}

          {/* for individual student */}
          {/* <Route
            path="/quizNew"
            element={
              <ProtectedQuizRoute>
                <StudentQuizComponent />
              </ProtectedQuizRoute>
            }
          >
            <Route index element={<StudentDashboard />} />
            <Route path="dashboard" element={<StudentDashboard />} />{" "}
            <Route path="registeredQuizzes" element={<RegisteredQuizzes2 />} />
            <Route path="ready/:quiz_id" element={<QuizReady2 />} />
            <Route path="completeQuizzes" element={<CompletedQuizzes2 />} />
            <Route path="aboutQuiz" element={<AboutQuiz2 />} />
            <Route
              path="terms-and-conditions"
              element={<TermsAndConditions2 />}
            />
            <Route path="startQuiz/:quiz_id" element={<StartQuiz2 />} />
          </Route> */}

          {/* all students */}
          <Route
            element={
              <ProtectedRoute>
                <StudentQuizLayout />
              </ProtectedRoute>
            }
          >
            <Route path="QuizHomePage" element={<QuizHomePage />} />
            <Route path="quiz-dashboard" element={<StudentQuizComponent2 />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<StudentDashboard />} />
              <Route
                path="registeredQuizzes"
                element={<RegisteredQuizzes2 />}
              />
              <Route path="ready/:quiz_id" element={<QuizReady2 />} />
              <Route path="completeQuizzes" element={<CompletedQuizzes2 />} />
              {/* <Route path="aboutQuiz" element={<AboutQuiz2 />} /> */}
              <Route
                path="terms-and-conditions"
                element={<TermsAndConditions2 />}
              />
              <Route path="startQuiz/:quiz_id" element={<StartQuiz2 />} />
            </Route>
            <Route path="quiz-syllabus" element={<Syllabus />} />
            <Route path="testimonials" element={<Testimonials />} />
            <Route path="participate" element={<Howtopartcipate />} />
            {/* <Route path="contact" element={<Contact />} /> */}
            <Route path="aboutQuiz" element={<AboutQuiz2 />} />
          </Route>
          {/* student documents */}
          <Route
            element={
              <ProtectedRoute>
                <StudentsDocumentLayout />
              </ProtectedRoute>
            }
          >
            <Route path="studentDocuments" element={<Documents />} />
            <Route exact path="/docFormTestRun" element={<DocFormTestRun />} />
            <Route exact path="/DocFormDraft/:isDraft" element={<Draft />} />
            <Route
              exact
              path="/myDocumentForms"
              element={<MyDocumentForms />}
            />
            <Route
              exact
              path="/myDocFormViewFill"
              element={<MyDocFormViewFill />}
            />
            <Route path="/myPrefills" element={<Show />} />
            {/* <Route path="/floatingBadge" element={<FloatingBadge />} /> */}
            <Route path="/Topinfobar" element={<Topinfobar />} />
          </Route>

          {/* ---- LMS Admin Module ---- */}
          <Route
            path="/lms"
            element={
              <ProtectedRoute>
                <LmsLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<LmsDashboard />} />
            <Route path="master-setup" element={<MasterSetup />} />
            <Route path="courses" element={<Courses />} />
            <Route path="payment-config" element={<PaymentConfig />} />
            <Route path="courses/:id" element={<CourseDetail />} />
            <Route path="students" element={<LmsStudents />} />
            <Route
              path="students/:studentId/history"
              element={<StudentHistoryLayout />}
            >
              <Route
                index
                element={<Navigate to="payment-details" replace />}
              />
              <Route
                path="payment-details"
                element={<StudentPaymentDetails />}
              />
              <Route
                path="course-requests"
                element={<StudentCourseRequests />}
              />
            </Route>
            <Route path="teachers" element={<LmsTeachers />} />
            <Route path="exams" element={<Exams />} />
            <Route path="exams/:examId/results" element={<OnlineExamResults />} />
            <Route
              path="manual-papers/:id/build"
              element={<ManualPaperBuilder />}
            />
            <Route path="live-classes" element={<LiveClasses />} />
            <Route path="recordings" element={<LmsRecordings />} />
            <Route path="audit-log" element={<LiveClassAuditLog />} />
            <Route path="attendance" element={<AttendanceManagement />} />
            <Route path="batches" element={<Batches />} />
            <Route path="classes" element={<LmsDashboard />} />
            <Route path="upload" element={<LmsDashboard />} />
            <Route path="reports" element={<LmsDashboard />} />
            <Route path="settings" element={<LmsDashboard />} />
            <Route path="notice-board" element={<NoticeBoard role="admin" />} />
          </Route>

          {/* ---- LMS Student Module ---- */}
          <Route
            path="/student-lms"
            element={
              <ProtectedRoute>
                <StudentLmsLayout />
              </ProtectedRoute>
            }
          >
            <Route
              index
              element={
                <Navigate to="student-courses/available-courses" replace />
              }
            />
            <Route
              path="courses"
              element={
                <Navigate to="student-courses/available-courses" replace />
              }
            />
            <Route path="courses/:id" element={<StudentCourseDetail />} />
            <Route
              path="available-courses"
              element={
                <Navigate to="student-courses/available-courses" replace />
              }
            />
            <Route
              path="enrolled-courses"
              element={
                <Navigate to="student-courses/enrolled-courses" replace />
              }
            />
            <Route path="student-courses" element={<StudentCourses />}>
              <Route
                index
                element={<Navigate to="available-courses" replace />}
              />
              <Route
                path="available-courses"
                element={<StudentAvailableCourses />}
              />
              <Route
                path="enrolled-courses"
                element={<StudentEnrolledCourses />}
              />
              <Route
                path="requested-courses"
                element={<StudentRequestedCourses />}
              />
              <Route
                path="payment-history"
                element={<StudentPaymentHistoryLedger />}
              />
            </Route>
            <Route path="exams" element={<StudentExams />} />
            <Route path="exams/:examId/online" element={<StudentOnlineExam />} />
            <Route path="attendance" element={<StudentAttendance />} />
            <Route
              path="manual-papers/:id/build"
              element={<StudentManualPaperViewer />}
            />
            <Route path="notice-board" element={<StudentNoticeBoard />} />
          </Route>

          {/* ---- LMS Teacher / User Module ---- */}
          <Route
            path="/teacher-lms"
            element={
              <ProtectedRoute>
                <TeacherLmsLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<TeacherDashboard />} />
            <Route path="courses" element={<TeacherCourses />} />
            <Route path="courses/:id" element={<CourseDetail />} />
            <Route path="live-classes" element={<TeacherLiveClasses />} />
            <Route path="recordings" element={<LmsRecordings />} />
            <Route path="audit-log" element={<LiveClassAuditLog />} />
            <Route path="attendance" element={<AttendanceManagement />} />
            <Route path="exams" element={<TeacherExams />} />
            <Route path="exams/:examId/results" element={<OnlineExamResults />} />
            <Route
              path="manual-papers/:id/build"
              element={<ManualPaperBuilder />}
            />
            <Route
              path="notice-board"
              element={<NoticeBoard role="teacher" />}
            />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
